import Carousel from "./Carousel"
import { t } from "i18next"

export default function ProjectCard({ slides, title, client, projectLabel, objet, date, reverse = false }) {
    return (
        <article className="mx-4 sm:mx-10 my-6 bg-white border border-gray-200 hover:shadow-md transition-shadow duration-300 overflow-hidden">
            <div className={`flex flex-col md:flex-row ${reverse ? 'md:flex-row-reverse' : ''}`}>
                
                {/* Carrousel */}
                <div className="w-full md:w-1/3 h-64 md:h-[420px] overflow-hidden shrink-0">
                    <Carousel slides={slides} />
                </div>

                {/* Contenu */}
                <div className="flex flex-col justify-center w-full md:w-2/3 p-6 md:p-10">
                    {/* Titre + barre d'accent */}
                    <div className="mb-6">
                        <span className="block w-12 h-1 bg-green-500 mb-4 rounded-full"></span>
                        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight">
                            {title}
                        </h2>
                    </div>

                    {/* Infos */}
                    <dl className="space-y-3 text-gray-600 text-base md:text-lg">
                        <div className="flex flex-col sm:flex-row sm:gap-2">
                            <dt className="font-semibold text-gray-800 min-w-[90px]">{t("clients")} :</dt>
                            <dd>{client}</dd>
                        </div>
                        <div className="flex flex-col sm:flex-row sm:gap-2">
                            <dt className="font-semibold text-gray-800 min-w-[90px]">{t("projets")} :</dt>
                            <dd>{projectLabel}</dd>
                        </div>
                        <div className="flex flex-col sm:flex-row sm:gap-2">
                            <dt className="font-semibold text-gray-800 min-w-[90px]">{t("objet")} :</dt>
                            <dd>{objet}</dd>
                        </div>
                        <div className="flex flex-col sm:flex-row sm:gap-2">
                            <dt className="font-semibold text-gray-800 min-w-[90px]">{t("date")} :</dt>
                            <dd>{date}</dd>
                        </div>
                    </dl>
                </div>
            </div>
        </article>
    )
}